import React from 'react';
import { Typography } from '@mui/material';
import { LinkManagementStatusMapper, LinkManagementStatus as Status } from '../types';

interface Props {
  status: Status;
}

const LinkReviewStatus = ({ status }: Props) => {
  switch (status) {
    case Status.OK:
      return (
        <Typography sx={{ width: '100%', textAlign: 'center' }} color="success.main">
          {LinkManagementStatusMapper[Status.OK]}
        </Typography>
      );
    case Status.FalsePositive:
      return (
        <Typography sx={{ width: '100%', textAlign: 'center' }} color="error">
          {LinkManagementStatusMapper[Status.FalsePositive]}
        </Typography>
      );
    default:
      return (
        <Typography sx={{ width: '100%', textAlign: 'center' }}>
          {LinkManagementStatusMapper[Status.Unspecified]}
        </Typography>
      );
  }
};

export default React.memo(LinkReviewStatus);
